export type ReportsReducerState = {
  filters: ReportsFilters;
  data?: ReportsData | null;
};

export type ReportsFilters = {
  order: 'asc' | 'desc';
  orderBy: ReportsOrderBy;
  query: string;
};

export type ReportsOrderBy = 'vendor' | 'date' | 'amount' | 'status';
export type ReportsControlFilter = 'freeText';

export type ReportsData = {
  reports: ReportsItem[];
};

export type ReportsItem = {
  id: string;
  title: string;
  from_date: string;
  to_date: string;
  receipts_count: number;
  sent_to: string[];
  status: ReportsStatus;
  creation_date: string;
};

export enum ReportsStatus {
  Sent = 'SENT',
  Pending = 'PENDING',
  Failed = 'FAILED',
}
